import React, { PureComponent, Fragment } from 'react'
import styled from 'styled-components'

const CardWrapper = styled.div`
  :hover {
    box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.1);
    transition: 0.2s linear;
  }
  display: flex;
  flex-direction: column;
  border: 1px solid #f0ecec;
  justify-content: center;
  align-items: center;
  width: 33.33%;
  padding: 60px 35px;
  @media (max-width: 768px) {
    width: 50%;
  }
  @media (max-width: 520px) {
    width: 100%;
  }
  & > img {
    height: 46px;
    width: 42px;
  }
  & > p:nth-child(2) {
    font-size: 21px;
    font-weight: normal;
    line-height: 1.52;
    text-align: center;
    color: #333333;
    padding: 30px 0 15px;
  }
  & > p:nth-child(3) {
    max-width: 312px;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.63;
    letter-spacing: 0.1px;
    text-align: center;
    margin: 0;
  }
  @media (max-width: 768px) {
    // box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.1);
    // margin-bottom: 20px;
    & > p:nth-child(2) {
      font-size: 24px !important;
      font-weight: normal !important;
      line-height: 1.33 !important;
      letter-spacing: normal !important;
      padding: 20px 0 10px;
    }
    & > p:nth-child(3) {
      font-size: 14px !important;
      font-weight: normal !important;
      line-height: 1.86 !important;
      letter-spacing: 0.1px !important;
      width: 100%;
    }
  }
`
const LinkWrapper = styled.a`
cursor:pointer;
  :hover {
    box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.1);
    transition: 0.2s linear;
  }
  display: flex;
  flex-direction: column;
  border: 1px solid #f0ecec;
  justify-content: center;
  align-items: center;
  width: 33.33%;
  padding: 60px 35px;
  @media (max-width: 768px) {
    width: 50%;
  }
  @media (max-width: 520px) {
    width: 100%;
  }
  & > img {
    min-width: 42px;
  }
  & > p:nth-child(2) {
    font-size: 21px;
    font-weight: normal;
    line-height: 1.52;
    text-align: center;
    color: #333333;
    padding: 30px 0 15px;
  }
  & > p:nth-child(3) {
    max-width: 312px;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.63;
    letter-spacing: 0.1px;
    text-align: center;
    margin: 0;
  }
  @media (max-width: 768px) {
    // box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.1);
    // margin-bottom: 20px;
    & > p:nth-child(2) {
      font-size: 24px !important;
      font-weight: normal !important;
      line-height: 1.33 !important;
      letter-spacing: normal !important;
      padding: 20px 0 10px;
    }
    & > p:nth-child(3) {
      font-size: 14px !important;
      font-weight: normal !important;
      line-height: 1.86 !important;
      letter-spacing: 0.1px !important;
      width: 100%;
    }
  }
`

export class CardComponent extends PureComponent {
  render() {
    const { link , parentLink } = this.props
    return (
      <Fragment>
        {parentLink ? <LinkWrapper href={parentLink}>
         
            <img src={this.props.img} alt={this.props.alt} />
    
            <p>{this.props.smallHeading}</p>
            <p>{this.props.description}</p>
          </LinkWrapper> 
          : <CardWrapper>
        {link ? (
          <a href={link} target="_blank">
          <img src={this.props.img} alt={this.props.alt} />
        </a>
        ): (
          <img src={this.props.img} alt={this.props.alt} />
        )}
          <p>{this.props.smallHeading}</p>
          <p>{this.props.description}</p>
        </CardWrapper>}
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CardComponent.js